import type { Fetch } from '../../shared/types';
import type { TransferApp } from '../types';

type RequestData = {
  accountId?: number;
};

export const getPublicTriggerApps = async (
  fetch: Fetch,
  { accountId }: RequestData
): Promise<TransferApp[]> =>
  fetch<TransferApp[]>('v1/trigger-implementations-meta/public/', {
    headers: {
      'x-account-id': String(accountId),
    },
  });

export default getPublicTriggerApps;
